import React from "react";

export function HomeFooter() {
  return (
    <footer className="text-center py-6 text-gray-600 text-xs font-mono border-t border-gray-800">
      Designed &amp; Built by Zaw Lin Naing
    </footer>
  );
}
